module.exports = "//public.zight.com/packs/media/images/onboarding/icons-record-0bc9c7921a4173c2543387de4ac3a8b3.svg";